import { Link } from 'react-router-dom';
import {Grid, Hidden, Grow, Typography} from '@material-ui/core';
import MenuPreviewCard from "./menuPreviewCard";
import food1 from '../../common/images/food/Micheladas.jpeg';
import food2 from '../../common/images/food/IMG_9744.jpeg';
import food3 from '../../common/images/food/shrimp_tacos.jpeg';
import food4 from '../../common/images/food/ct_food1.jpeg';
import food5 from '../../common/images/food/IMG_991.jpg';
import food6 from '../../common/images/food/IMG_9915.jpg';
import food7 from '../../common/images/food/IMG_9745.jpeg';
import food8 from '../../common/images/food/food8.jpeg';
import food9 from '../../common/images/food/img_12.jpeg';
import food10 from '../../common/images/food/IMG_9914.jpg';
import {useEffect, useRef, useState} from "react";

import ViewMenuButton from "./viewMenuButton";

const MenuPreview = () => {
  const [pageLocation, setPageLocation] = useState(0);

  // const handleScroll = () => setPageLocation(window.pageYOffset);

  // useEffect(() => {
  // // eslint-disable-next-line no-restricted-globals
  //   window.addEventListener("scroll", handleScroll);
  // });

  return (
      <div className='menu-preview-container'>
        <Grid container justify="center" alignItems="center" spacing={1}>
          <Grid item container justify="center" alignItems="center" spacing={1} xs={12} sm={11} md={10}>

          <ViewMenuButton />

          <Grid item xs={5}><MenuPreviewCard img={food1} threshold={.25} slideDirection="right" /></Grid>
          <Grid item xs={3}><MenuPreviewCard img={food2} threshold={.5} slideDirection="left" /></Grid>
          <Grid item xs={4}><MenuPreviewCard img={food3} threshold={1} slideDirection="left" /></Grid>


          <Grid item xs={4}><MenuPreviewCard img={food4} threshold={.5} slideDirection="right" /></Grid>
          <Grid item xs={3}><MenuPreviewCard img={food9} threshold={.25} slideDirection="right" /></Grid>
          <Grid item xs={5}><MenuPreviewCard img={food5} threshold={1} slideDirection="left" /></Grid>

          <Grid item sm={3} xs={6}><MenuPreviewCard img={food7} threshold={.75} slideDirection="right" /></Grid>
          <Grid item sm={3} xs={6}><MenuPreviewCard img={food8} threshold={.5} slideDirection="right" /></Grid>
          <Hidden xsDown>
            <Grid item sm={3}><MenuPreviewCard img={food6} threshold={.25} slideDirection="left" /></Grid>
            <Grid item sm={3}><MenuPreviewCard img={food10} threshold={1} slideDirection="left" /></Grid>
          </Hidden>

        </Grid>
      </Grid>
    </div>
  );
};

export default MenuPreview;
